import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { baseModulesRoutes } from '@app/config';

@Component({
  selector: 'app-modules-list',
  templateUrl: './modules-list.component.html',
  styleUrls: ['./modules-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModulesListComponent {
  @Input() isMobileMenu: boolean;
  baseModulesRoutes = baseModulesRoutes;
}
